import { GuiDetailBenutzerAnfallstelle } from "../D/GuiDetailBenutzerAnfallstelle";

// Support: Standort-/Anfallstellen-Zuordnung, gleiches Verhalten wie in den Stammdaten
export class GuiDetailSupportBenutzerAnfallstelle extends GuiDetailBenutzerAnfallstelle {
}
